import { Checkbox } from '@cian/ui-kit';

import * as React from 'react';

import { EInfrastructure, type NonEmptyArray } from '@/packages/JsonQuery';

import { Filter } from '../common/Filter';
import { InlineFilter } from '../common/InlineFilter';
import { InlineFilterGroup } from '../common/InlineFilterGroup';

import { ExpandWrapper } from './internal/components/ExpandWrapper';
import { Layout } from './internal/components/Layout';

interface IInfrastructureOption {
  label: string;
  value: EInfrastructure;
}

const INFRASTRUCTURE_OPTIONS: IInfrastructureOption[] = [
  { label: 'Автомойка', value: EInfrastructure.CarWash },
  { label: 'Автосервис', value: EInfrastructure.CarService },
  { label: 'Аптека', value: EInfrastructure.Pharmacy },
  { label: 'Ателье одежды', value: EInfrastructure.ClothesStudio },
  { label: 'Банкомат', value: EInfrastructure.ATM },
  { label: 'Бассейн', value: EInfrastructure.Pool },
  { label: 'Буфет', value: EInfrastructure.Buffet },
  { label: 'Выставочно-складской комплекс', value: EInfrastructure.WarehouseComplex },
  { label: 'Гостиница', value: EInfrastructure.Hotel },
  { label: 'Кафе', value: EInfrastructure.Cafe },
  { label: 'Кинотеатр', value: EInfrastructure.Cinema },
  { label: 'Конференц-зал', value: EInfrastructure.ConferenceRoom },
  { label: 'Медицинский центр', value: EInfrastructure.MedicalCenter },
  { label: 'Минимаркет', value: EInfrastructure.Minimarket },
  { label: 'Нотариальная контора', value: EInfrastructure.NotaryOffice },
  { label: 'Отделение банка', value: EInfrastructure.BankDepartment },
  { label: 'Парк', value: EInfrastructure.Park },
  { label: 'Ресторан', value: EInfrastructure.Restaurant },
  { label: 'Салон красоты', value: EInfrastructure.BeautyShop },
  { label: 'Складские помещения', value: EInfrastructure.Warehouse },
  { label: 'Столовая', value: EInfrastructure.Canteen },
  { label: 'Супермаркет', value: EInfrastructure.Supermarket },
  { label: 'Торговая зона', value: EInfrastructure.ShoppingArea },
  { label: 'Фитнес-центр', value: EInfrastructure.FitnessCentre },
  { label: 'Фотосалон', value: EInfrastructure.Studio },
  { label: 'Центральная рецепция', value: EInfrastructure.CentralReception },
];

interface IInfrastructureProps {
  value: NonEmptyArray<EInfrastructure> | null;
  onChange(value: NonEmptyArray<EInfrastructure> | null): void;
}

export const Infrastructure: React.FC<IInfrastructureProps> = ({ value, onChange }) => {
  const [isExpanded, setIsExpanded] = React.useState(false);
  const expandedText = isExpanded ? 'Свернуть' : 'Вся инфраструктура';

  const handleToggleExpanded = React.useCallback(() => {
    setIsExpanded(state => !state);
  }, []);

  const handleInfrastructureChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    infrastructure: EInfrastructure,
  ): void => {
    const { checked } = event.target;
    let nextValue: EInfrastructure[] = [...(value || [])];

    if (checked) {
      nextValue.push(infrastructure);
    } else {
      nextValue = nextValue.filter(v => v !== infrastructure);
    }

    onChange(nextValue.length > 0 ? (nextValue as NonEmptyArray<EInfrastructure>) : null);
  };

  return (
    <Filter id="advancedFilter_infrastructure" label="Инфраструктура">
      <ExpandWrapper isExpanded={isExpanded} text={expandedText} onToggle={handleToggleExpanded}>
        <InlineFilterGroup>
          <Layout>
            {INFRASTRUCTURE_OPTIONS.map(infrastructureOption => (
              <InlineFilter key={`${infrastructureOption.label}_${infrastructureOption.value}`}>
                <Checkbox
                  checked={value ? value.includes(infrastructureOption.value) : false}
                  label={infrastructureOption.label}
                  onChange={event => handleInfrastructureChange(event, infrastructureOption.value)}
                />
              </InlineFilter>
            ))}
          </Layout>
        </InlineFilterGroup>
      </ExpandWrapper>
    </Filter>
  );
};
